module.exports = fox._r("images/valentines/gift-13.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/valentines/gift-13.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/valentines/gift-13.png
// module id = 214
// module chunks = 4